/* The strip scrolls sideways when its tabs do not fit, and only sideways: the active tab's indicator reaching onto
   the line must not make it scroll a pixel up and down. */
.list {
  display: flex;
  gap: var(--space-1);
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  border-bottom: 1px solid var(--color-border);
  scrollbar-width: none;
}

.tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: var(--space-1-5);
  height: var(--size-control-lg);
  padding: 0 var(--space-2-5);
  color: var(--color-fg-muted);
  font-size: var(--text-base);
  font-weight: var(--weight-medium);
  white-space: nowrap;
  cursor: pointer;
}

.tab svg {
  width: var(--size-icon);
  height: var(--size-icon);
}

/* Inside the tab: an outline outside it would be clipped by the scrolling strip to two stray vertical lines. */
.tab:focus-visible {
  border-radius: var(--radius-sm);
  outline-offset: -2px;
}

.tab:hover {
  color: var(--color-fg);
}

.tab[data-state="active"],
.tab[aria-current="page"] {
  color: var(--color-fg);
}

.tab[data-state="active"]::after,
.tab[aria-current="page"]::after {
  content: "";
  position: absolute;
  right: var(--space-2);
  bottom: -1px;
  left: var(--space-2);
  height: 2px;
  border-radius: var(--radius-full);
  background: var(--color-accent);
}

.content:focus-visible {
  outline-offset: var(--space-1);
}
